export default __webpack_public_path__ + "static/media/attachment-ic-16px.23c45307.svg";